import React from 'react'

import { List, ListElement } from './'

const PlainList = ({ header, info, elements, footer, emptyState }) => {
	return (
		<List
			header={header}
			info={info}
			body={
				elements.length > 0
					? elements.map((link, i) => {
							return (
								<ListElement key={i} {...link} noShadow={true} />
							)
						})
					: <ListElement
							descCenter
							desc={emptyState}
							noShadow={true}
						/>
			}
			footer={footer}
		/>
	)
}
PlainList.propTypes = {
	elements: React.PropTypes.oneOfType([
		React.PropTypes.array,
		React.PropTypes.object
	])
}

export default PlainList



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/PlainList.js